import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=716dec7d&scoped=true&"
var script = {}
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=716dec7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716dec7d",
  null
  
)

export default component.exports